const getters = {
  // app
  appContext: (state) => state.app.appContext,
  appCode: (state) => state.app.appCode,
  appLanguage: (state) => state.app.appLanguage,
  user: (state) => state.auth.user,
  theme: (state) => state.style.systemStyle.theme,
}
export default getters
